import update from 'immutability-helper'
import * as types from './types'

export interface SharedTab {
  id: string;
  state: object;
  type: number,
}
export interface IState {
  tabs: SharedTab[]
}
const initialState: IState = {
  tabs: []
}

const switchMap: {
  [key in keyof typeof types]?: (state: IState, action: Partial<{ type: keyof typeof types }>) => IState
} = {}

switchMap[types.UPDATE_SHARED_TABS] = (state, action) => update(state, {
  tabs: {
    $set: action.newTabs
  }
})

export default (state = initialState, action) => switchMap[action.type] ? switchMap[action.type](state, action) : state
